import { useQuery } from 'react-query';
import { BASE_URL } from '../configs/config';

interface SessionResponse {
  sessionId: string;
  expiresAt: string;
}

const useGetSession = (seatId: string, stadiumId: string, enabled: boolean) => {
  return useQuery<SessionResponse | null>(
    ['getSession', stadiumId, seatId],
    async () => {
      const params = new URLSearchParams({
        seatId,
        stadiumId,
      });

      const response = await fetch(`${BASE_URL}get_session?${params.toString()}`);

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const error: any = new Error(errorBody.error || `Failed to fetch session: ${response.statusText}`);
        error.status = response.status;
        throw error;
      }
      const data = await response.json();
      return data;
    },
    {
      enabled: !!seatId && !!stadiumId && enabled,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );
};

export default useGetSession;
